import './App.css';
import { useState, useRef, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { BrowserRouter, Routes, Route} from "react-router-dom";
import UpperNavbar  from './components/elements/UpperNavbar';
import Body from './components/Body';
import Home from './components/pages/Home';
import Investments from './components/pages/Investments';
import InterestCalculation from './components/pages/InterestCalculation';
import CashFlow from './components/pages/CashFlow';
import auth from './components/api/auth';


function App() {

  const [loggedIn, setLoggedIn] = useState(false);
  const [sessionToken, setSessionToken] = useState(localStorage.getItem("sid") === null || localStorage.getItem("sid") === "undefined" ? null : localStorage.getItem("sid"));
  const [password, setPassword] = useState();
  const [loginError, setLoginError] = useState(false);

  const dataLoaded = useRef(false);

  useEffect(() => {
    if(sessionToken !== "non" && sessionToken !== null) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
 }, [sessionToken]);

  const handleLogin = ()=> {
    getSessionToken();
  }

  const getSessionToken = async ()=> {  
    const fetchList = async () => {
        const config = {
            headers: {
              Authorization: 'Bearer ' + password}
        };
        const response = await auth.get('', config);
        if(response.data.sessionToken !== "non") {
          setSessionToken(response.data.sessionToken);
          setLoggedIn(true);
          setLoginError(false);
          localStorage.setItem("sid", response.data.sessionToken);
        } else {
          setLoggedIn(false);
          setLoginError(true);
        }
    }
    if (dataLoaded.current === false) {
        fetchList();
    }
    return ()=> { dataLoaded.current = true; }
}

  return (
    <div className="App">
      {loggedIn ? 
      <>
      <BrowserRouter>
      <UpperNavbar></UpperNavbar>
        <Routes>
          <Route path="/" element={<Body />}>
            <Route index element={<Home/>} />
            <Route path="/investments" element={ <Investments sessionToken={sessionToken}/>} />
            <Route path="/interestcalculation" element={ <InterestCalculation sessionToken={sessionToken}/>} />
            <Route path="/cashflow" element={ <CashFlow sessionToken={sessionToken}/>} />
          </Route>
        </Routes>
      </BrowserRouter>     
      </>
       : 
        <Modal show="show">
        <Modal.Header>
            <Modal.Title>Please log in</Modal.Title>
        </Modal.Header>
        <Modal.Body>
               <Form.Group className="mb-3" controlId="ControlInput1">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" onChange={(e) => setPassword(e.target.value)}/>
                </Form.Group>
                {loginError ? "Problem with password" : ""}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="success" onClick={handleLogin}>
                Log in
            </Button>
        </Modal.Footer>
    </Modal>
      
      }
    </div>
  );
}

export default App;
